var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editResource }
            },
            [_vm._v("Edit Resource")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.resource
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.resource.newsResourcesId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Resource Type ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.getResourceType(_vm.resource.resourceType)))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Header")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.resource.articleHeader))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Article URL")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.resource.articleUrl))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Image")]),
                _vm._v(" "),
                _c("td", [
                  _vm.resource.imageUrl
                    ? _c("img", {
                        staticClass: "table-thumbnail",
                        attrs: {
                          src: _vm.resource.imageUrl,
                          title: _vm.resource.imageUrl
                        }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.resource.description))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Video Code")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.resource.videoCode))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.resource.isActive == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Resource Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-114a4f2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114a4f2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Resources/ResourceDetails.vue
// module id = J6F3
// module chunks = 0